<div style="position: fixed; top: 0px; left: 0px; text-align: center; margin: auto; background-color: white;">
    <qrcode [qrdata]="selectedQrCode" [width]="400" [errorCorrectionLevel]="'M'"></qrcode>
    <div style="font-size:2em; font-weight: bold;">{{ selectedQrCode }}</div>
</div>